<div mat-dialog-title><mat-icon style="margin-right: 8px;">api</mat-icon>{{ 'ChangeApi' | translate:locale.language }}
  <button mat-stroked-button (click)="disableChangeEnvironments()" style="float: right;">{{ 'Disable Change Environment' | translate:locale.language }}</button>
</div>
<div mat-dialog-content>
  <div class="row">
    <p>Select the environment to target:</p>
  </div>
  <div class="row">
    <mat-form-field>
      <input matInput type="url" required autocomplete="off" [formControl]="embeddedHostControl" placeholder="{{ 'Embedded Host (default: ' + defaultEmbeddedHost + ')' }}" />
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field>
      <input matInput type="url" required autocomplete="off" [formControl]="hickoryHostControl" placeholder="{{ 'Hickory Host (default: ' + defaultHickoryHost + ')' }}" />
    </mat-form-field>
  </div>
  <div class="row">

  </div>
</div>
<div mat-dialog-actions class="button-row right">
  <button mat-stroked-button color="primary" [disabled]="embeddedHostControl.invalid || hickoryHostControl.invalid" (click)="updateEnvironments()">Update Environments</button>
  <button mat-stroked-button (click)="resetEnvironments()">{{ 'Reset' | translate:locale.language }}</button>
  <button mat-stroked-button id="close" mat-dialog-close>{{ 'Close' | translate:locale.language }}</button>
</div>